class BackToTopButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });

    window.addEventListener("scroll", () => {
      if (window.scrollY > 200) {
        this.fadeIn();
      } else {
        this.fadeOut();
      }
    });
  }

  fadeIn() {
    this.style.opacity = "1";
  }

  fadeOut() {
    this.style.opacity = "0";
  }
}

customElements.define("back-to-top", BackToTopButton);
